<template>
  <div class="login">
    <Navbar :default-bg="false" path="/"/>
    <div class="title">
      <span>登 录</span>
      <span>L O G I N /</span>
    </div>
    <div class="form">
      <div class="form-item">
        <input type="text" placeholder="请输入手机号" v-model="phone"
               @input="changeInputVal($event,/^(0+)|[^\d]+/g,'phone',0,11)"/>
      </div>
      <div class="form-item">
        <input type="text" placeholder="请输入图片验证码" v-model="code"
               @input="changeInputVal($event,/^[^\d]+/g,'code',0,4)"/>
        <img :src="verifyCodeImg" alt="" @click="getImgVerifyCode">
      </div>
      <div class="form-item">
        <input type="text" placeholder="请输入手机验证码" v-model="verifyCode"
               @input="changeInputVal($event,/^[^\d]+/g,'verifyCode',0,6)"/>
        <verify-button :phone="phone" :type="2" :code="code" :token="token" @resetImgVerifyCode="getImgVerifyCode"></verify-button>
      </div>
    </div>
    <div class="agreement">
      <div class="dot" @click="agree = !agree">
        <span v-if="agree"></span>
      </div>
      <p>
        我已阅读并同意《<span @click="toPages('/userAgreeOn')">用户注册协议</span>》、《<span
          @click="toPages('/serviceTerms')">用户服务条款</span>》、
        《<span @click="toPages('/userConceal')">隐私协议</span>》
      </p>
    </div>
    <div class="submit">
      <button class="themeColor" @click="login">登 录</button>
    </div>
    <div class="register">
      <button @click="toPages('/register', phone)">注册账号</button>
    </div>
    <div class="other-login clearfix">
      <div class="other">
        <span>其他登录方式</span>
      </div>
      <div class="wx-login" @click="getEmpower">
        <img src="../assets/images/login_wechat.png" alt="">
        <span>微信登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/NavBar";
import {mixins} from "../mixins";
import VerifyButton from "../components/verifyButton";
import {Toast} from "vant";

export default {
  name: "Login",
  components: {VerifyButton, Navbar},
  mixins: [mixins],
  data() {
    return {
      verifyCodeImg: "",
      code: null,
      phone: null,
      token: "",
      verifyCode: null,//手机验证码
      agree: true,
      s: false
    }
  },
  created() {
    this.getImgVerifyCode();
    let edit = JSON.parse(sessionStorage.getItem('edit'))
    if (edit) {
      this.$router.go(0);
      sessionStorage.setItem('edit', 'false');
    }
  },
  methods: {
    changeInputVal(e, reg, key, min = 0, max) {
      this[key] = e.target.value.replace(reg, '').slice(min, max);
    },
    //登录
    login() {
      if (!this.agree) {
        return Toast('请同意并勾选用户协议');
      }
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.phone)) {
        return Toast('手机号码不正确，请重新输入');
      }
      let data = {
        mobile: this.phone,
        verifyCode: this.verifyCode,
        verifyToken: sessionStorage.getItem('smsToken')
      }
      this.$post('user/mobileLogin', data).then(result => {
        if (result.status === 200) {
          // this.$router.push('/');
          let local = decodeURIComponent(window.sessionStorage.getItem("skipAddress")) || this.BASE.BASE_URL;
          localStorage.setItem('user_token', result.data.token);//登录token
          localStorage.setItem('user_type', result.data.userType);//userType 0是普通用户，1医护人员，2配送人员
          window.location.href = local;
        } else {
          return Toast(result.msg);
        }
      });
    },
    //跳转页面
    toPages(url, phone = '') {
      if (phone) {
        this.$router.push({path: url, query: {phone: phone}})
      } else {
        // if (url === "/empower") window.sessionStorage.setItem("skipAddress", encodeURIComponent(window.location.href))
        this.$router.push(url);
      }
    },
    getEmpower() {
      if (!this.agree) {
        return Toast("请同意并勾选用户协议");
      }
      // const local = decodeURIComponent(window.sessionStorage.getItem("skipAddress")) || this.BASE.BASE_URL;
      const local = this.BASE.BASE_URL + "/loading";

      window.location.replace(`${this.BASE.WECHAT_AUTHORIZE_URL}?returnUrl=${local}`);
    },
  }
}
</script>

<style scoped lang="less">
.login {
  height: 100vh;
  background: #FFFFFF;
  font-size: 12px;

  p {
    padding: 0;
    margin: 0;
  }

  .title {
    display: flex;
    flex-direction: column;
    padding: 0 25px;
    box-sizing: border-box;
    margin-top: 38px;

    span:nth-child(1) {
      font-size: 24px;
      font-weight: bold;
    }

    span:nth-child(2) {
      margin-top: 11px;
      color: #CCCCCC;
    }
  }

  .form {
    margin-top: 40px;
    padding: 0 25px;
    box-sizing: border-box;
    font-size: 15px;

    .form-item:first-child {
      margin-top: 0;
    }

    .form-item {
      height: 50px;
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #DDDDDD;

      input {
        flex: 1;
        border: none;
      }

      img {
        width: 100px;
        height: 35px;
      }
    }
  }

  .agreement {
    margin-top: 22px;
    padding: 0 25px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .dot {
      width: 15px;
      height: 15px;
      background: #E6EFFF;
      border: 1px solid #126AFC;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        width: 8px;
        height: 8px;
        background: #126AFC;
        border-radius: 50%;
      }
    }

    p {
      margin-left: 5px;
      line-height: 1.4;
      flex: 1;
      color: #999999;

      span {
        color: #000000;
      }
    }
  }

  .submit {
    margin-top: 30px;
    padding: 0 15px;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 50px;
      font-size: 18px;
      font-weight: bold;
      border: none;
      background: transparent;
      border-radius: 25px;
    }
  }

  .register {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    button {
      color: #126AFC;
      background: transparent;
      border: none;
      font-size: 15px;
    }
  }

  .other-login {
    margin-top: 30px;

    .other {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #999999;

      span {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      span::before {
        content: "";
        display: block;
        width: 100px;
        height: 1px;
        background: #CCCCCC;
        margin-right: 17px;
      }

      span::after {
        content: "";
        display: block;
        width: 100px;
        height: 1px;
        background: #CCCCCC;
        margin-left: 17px;
      }
    }

    .wx-login {
      margin-top: 25px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 20px;

      img {
        width: 45px;
        height: 45px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>